/***
 * Created on 2024/1/8
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useState} from 'react';
import ModalDialog from "../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";
import Cookies from 'js-cookie';


function SetupAuthenticatorDialog({...props}) {
    const { t } = useTranslation();
    const [isIgnore, setIsIgnore] = useState(false);

    const closeModal = () => {
        if (isIgnore) {
            Cookies.set('noAuthenticatorWarning', 'true', {expires: 30});
        }
        const query = new URLSearchParams(window.location.search);

        query.delete('switch_account');
        if (query.has('state')) {
            location.href = `/login?${query.toString()}`;
        }
        else {
            location.href = `/login?state=/account?${query.toString()}`;
        }
    }

    const onSubmit = () => {
        if (isIgnore) {
            Cookies.set('noAuthenticatorWarning', `${isIgnore}`, {expires: 30});
        }
        const query = new URLSearchParams(window.location.search);
        query.delete('switch_account');
        location.href = `/login?state=/account/security?${query.toString()}`;
    }

    return (
        <ModalDialog {...props} closeModal={closeModal} title={t('@Authenticator Apps is more secure@')} submitAction={onSubmit}>
            <div className="dialog-content">
                <p>
                    {t('@We recommend to use the Authenticator app since its tied directly to your physical device and the codes are not delivered over the mobile network which is more secure and safe.@')}
                </p>
                <p>
                    {t('@Other major benefits of Authenticator apps are that codes expires every 30 seconds and it also works offline to provide optimal security.@')}
                </p>
                <div className="dialog__form-group">
                    <div className="comp-checkbox">
                        <label className="q-checkbox">
                            <input type="checkbox" name="checkbox-checked" checked={isIgnore} onChange={()=>setIsIgnore(prev => !prev)}/>
                            {t('@GENERAL_DO_NOT_SHOW_AGAIN@')}
                        </label>
                    </div>
                </div>
            </div>
        </ModalDialog>
    );
}

export default SetupAuthenticatorDialog;